import { useEditor, useNode } from "@craftjs/core";
import { Grid, Paper } from "@mui/material";
import SettingsItem from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemRadio from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItemRadio";
import SettingsItemText from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";

const Settings = () => {
    const { id } = useNode();
    const { displayName, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection
                title="Dimensions"
                props={["width", "height"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ width, height }: any) => {
                    return `${width || 0} x ${height || 0}`;
                }}
            >
                <SettingsItem propKey="width" type="text" label="Width" />
                <SettingsItem propKey="height" type="text" label="Height" />
            </SettingsSection>
            <SettingsSection
                title="Appearance"
                props={["background", "elevation", "radius"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ background, elevation, radius }: any) => {
                    return (
                        <Paper
                            square={radius === "0"}
                            elevation={elevation || 0}
                            style={{
                                background: background && `rgba(${Object.values(background)})`,
                                padding: "8px",
                            }}
                        >
                            <span>Example</span>
                        </Paper>
                    );
                }}
            >
                <SettingsItem propKey="radius" type="radio" label="Corners" fullWidth>
                    <SettingsItemRadio value={0} label="Square" />
                    <SettingsItemRadio value={8} label="Rounded" />
                </SettingsItem>
                <SettingsItem propKey="appearance" type="radio" label="Display">
                    <SettingsItemRadio value={"flex"} label="Flex" />
                    <SettingsItemRadio value={"block"} label="Block" />
                </SettingsItem>
                <SettingsItem propKey="wrap" type="radio" label="Wrap containers">
                    <SettingsItemRadio value={"yes"} label="Yes" />
                    <SettingsItemRadio value={"no"} label="No" />
                </SettingsItem>
                <SettingsItem fullWidth propKey="elevation" index={0} type="slider" min={0} max={3} label="Elevation" />
                <SettingsItem fullWidth propKey="background" type="background" label="Background" />
            </SettingsSection>
            <SettingsSection
                title="Margin"
                props={["margin"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ margin }: any) => {
                    return `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${margin[3] || 0}px`;
                }}
            >
                <SettingsItem propKey="margin" index={0} type="slider" label="Top" />
                <SettingsItem propKey="margin" index={1} type="slider" label="Right" />
                <SettingsItem propKey="margin" index={2} type="slider" label="Bottom" />
                <SettingsItem propKey="margin" index={3} type="slider" label="Left" />
            </SettingsSection>
            <SettingsSection
                title="Padding"
                props={["padding"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ padding }: any) => {
                    return `${padding[0] || 0}px ${padding[1] || 0}px ${padding[2] || 0}px ${padding[3] || 0}px`;
                }}
            >
                <SettingsItem propKey="padding" index={0} type="slider" label="Top" />
                <SettingsItem propKey="padding" index={1} type="slider" label="Right" />
                <SettingsItem propKey="padding" index={2} type="slider" label="Bottom" />
                <SettingsItem propKey="padding" index={3} type="slider" label="Left" />
            </SettingsSection>
            <SettingsSection title="Alignment">
                <SettingsItem propKey="flexDirection" type="radio" label="Flex Direction">
                    <SettingsItemRadio value="row" label="Row" />
                    <SettingsItemRadio value="column" label="Column" />
                </SettingsItem>
                <SettingsItem propKey="fillSpace" type="radio" label="Fill space">
                    <SettingsItemRadio value="yes" label="Yes" />
                    <SettingsItemRadio value="no" label="No" />
                </SettingsItem>
                <SettingsItem propKey="alignItems" type="radio" label="Align Items">
                    <SettingsItemRadio value="flex-start" label="Flex start" />
                    <SettingsItemRadio value="center" label="Center" />
                    <SettingsItemRadio value="flex-end" label="Flex end" />
                    <SettingsItemRadio value="stretch" label="Stretch" />
                </SettingsItem>
                <SettingsItem propKey="justifyContent" type="radio" label="Justify Content">
                    <SettingsItemRadio value="flex-start" label="Flex start" />
                    <SettingsItemRadio value="center" label="Center" />
                    <SettingsItemRadio value="flex-end" label="Flex end" />
                </SettingsItem>
            </SettingsSection>
        </>
    );
};

export default Settings;
